import type { SerializedConstructor } from '@langchain/core/load/serializable';

import { parseLangSmithParamsFromRun } from '@/utils/langsmith-params';

import { serializedModelNameEquals } from './utils';

export const DEFAULT_MODEL = 'mixtral-8x7b-32768';

export function inferChatGroqManifestFromRun(
  params: ReturnType<typeof parseLangSmithParamsFromRun> | null,
  serializedModel: SerializedConstructor | null
): SerializedConstructor | null {
  if (
    !serializedModelNameEquals(serializedModel, 'ChatGroq') &&
    (params?.ls_provider !== 'groq' ||
      !(params?.ls_model_type == null || params.ls_model_type === 'chat'))
  ) {
    return null;
  }

  return {
    lc: 1,
    type: 'constructor',
    id: ['langchain_groq', 'chat_models', 'ChatGroq'],
    kwargs: {
      ...(params?.ls_model_name !== undefined && {
        model: params.ls_model_name,
        model_name: undefined,
      }),
      ...(params?.ls_temperature !== undefined && {
        temperature: params.ls_temperature,
      }),
      ...(params?.ls_max_tokens !== undefined && {
        max_tokens: params.ls_max_tokens,
      }),
      groq_api_key: {
        lc: 1,
        type: 'secret',
        id: ['GROQ_API_KEY'],
      },
    },
  };
}
